module.exports = __webpack_public_path__ + "static/media/bg9.0f29bd7e.jpg";